/**
 * Plan slot items are { columnId, eventId } (see useWeeklyPlan).
 */
export function planRefsEqual(a, b) {
  if (!a || !b) return false;
  return String(a.columnId) === String(b.columnId) && String(a.eventId) === String(b.eventId);
}

/**
 * True if the ref is already stored for this plan day index (any hour key for that date).
 */
export function isPlanRefOnDay(slots, day, getSlotKey, ref) {
  if (!ref || ref.columnId == null || ref.eventId == null || typeof getSlotKey !== "function") {
    return false;
  }
  const s = slots || {};
  for (let hour = 0; hour < 24; hour++) {
    const key = getSlotKey(day, hour);
    const items = s[key] || [];
    for (const item of items) {
      if (planRefsEqual(item, ref)) return true;
    }
  }
  return false;
}
